import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import StoryImage from '../../assets/lavisha.jpeg';

const Page2 = () => {
    return (
        <Container
            maxWidth={false}
            sx={{
                paddingTop: '10px',
                paddingBottom: '50px',
                backgroundColor: '#FFFFFF',
                borderRadius: {
                    xs: '0px', // No border-radius on mobile
                    md: '20px', // Border-radius for desktop
                },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingLeft: 0, // Remove padding on mobile
                paddingRight: 0, // Remove padding on mobile
            }}
        >
            <Grid container spacing={4} alignItems="stretch">
                {/* Left Column */}
                <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Box
                        sx={{
                            padding: {
                                xs: '20px 16px', // Adjust padding for mobile
                                md: '20px',
                            },
                            borderRadius: '20px',
                            backgroundColor: '#fff',
                            border: {
                                xs: 'none',
                                md: '1px solid rgba(221, 221, 221, 1)',
                            },
                            height: '100%', // Ensure the height matches the other column
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: 'ClaireMurphy',
                                fontSize: {
                                    xs: '24px',
                                    md: '32px',
                                },
                                fontWeight: 400,
                                textAlign: 'left',
                                color: 'rgba(0, 48, 135, 1)',
                                marginBottom: '10px',
                            }}
                        >
                            ABOUT
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'ClaireMurphy',
                                fontSize: {
                                    xs: '40px',
                                    md: '60px',
                                },
                                fontWeight: 400,
                                textAlign: 'left',
                                color: 'rgba(0, 48, 135, 1)',
                                marginBottom: '20px',
                            }}
                        >
                            LAVISHA<span style={{ fontSize: '0.6em', verticalAlign: 'super' }}>✦</span>
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: '18px',
                                fontWeight: 400,
                                letterSpacing: '-0.02em',
                                textAlign: 'left',
                                color: 'rgba(136, 136, 136, 1)',
                                marginBottom: '30px',
                            }}
                        >
                            Lavisha is a group of beauty and wellness entrepreneurs in Malaysia with the goal of building a comprehensive wellness empire, while maintaining an exclusive network of business partners.
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: '20px',
                                fontWeight: 500,
                                letterSpacing: '-0.02em',
                                textAlign: 'left',
                                color: 'rgba(61, 61, 61, 1)',
                                marginBottom: '20px',
                            }}
                        >
                            Bielenda has been producing the highest quality natural face and body care cosmetics for over 30 years. This modern Polish brand has been committed since its inception to the belief that products based on natural active ingredients provide the most comprehensive, yet safe, and skin-friendly care.
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: '20px',
                                fontWeight: 500,
                                letterSpacing: '-0.02em',
                                textAlign: 'left',
                                color: 'rgba(61, 61, 61, 1)',
                                marginBottom: '20px',
                            }}
                        >
                            Lavisha brings in Bielenda Supremelab as part of our product offerings. Bielenda Professional has been present in the professional cosmetics market since 2004 – it can undoubtedly be called one of the leaders in this industry. Bielenda Professional treatments are available in beauty salons, aesthetic medicine clinics, spas, as well as in beauty schools and universities.
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand, sans-serif',
                                fontSize: '20px',
                                fontWeight: 500,
                                letterSpacing: '-0.02em',
                                textAlign: 'left',
                                color: 'rgba(61, 61, 61, 1)',
                                marginBottom: '30px',
                            }}
                        >
                            Bielenda Professional decided to leverage their extensive experience in creating products for professionals to create advanced home care products. They wanted to provide a wider audience with access to formulas inspired by their successes in professional cosmetology. They decided to put the knowledge of Bielenda Professional's research and development laboratory and the brand's experts into practice, and thus, in 2017, the first SUPREMELAB product lines were created.
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Quicksand',
                                fontSize: '12px',
                                fontWeight: 500,
                                lineHeight: '20px',
                                letterSpacing: '0.1em',
                                textAlign: 'left',
                                color: 'rgba(136, 136, 136, 1)',
                            }}
                        >
                            OUR STORY
                        </Typography>
                    </Box>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box
                        component="img"
                        src={StoryImage} // Replace with actual image path
                        alt="Lavisha Story"
                        sx={{
                            width: '100%',
                            height: {
                                xs: 'auto', // Maintain aspect ratio on mobile
                                md: '500px', // Reduced height for desktop
                            },
                            maxHeight: {
                                xs: '400px', // Max height on mobile
                                md: '500px', // Max height on desktop
                            },
                            borderRadius: {
                                xs: '0px', // No border-radius on mobile
                                md: '20px', // Border-radius for desktop
                            },
                            objectFit: 'cover', // Maintain the aspect ratio while filling the height
                            boxShadow: {
                                xs: 'none', // No shadow on mobile
                                md: '0 2px 8px rgba(0, 0, 0, 0.1)', // Shadow for desktop
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default Page2;
